import type { ReactNode } from 'react'

interface TagLabelProps {
  children?: ReactNode
  showPrefix?: boolean
  tag: string
}

export function TagPrefix() {
  return <span className="tag-name__prefix" aria-hidden="true">#</span>
}

/** Keeps the visual hashtag secondary to the tag name in every tag surface. */
export function TagLabel({ children, showPrefix = true, tag }: TagLabelProps) {
  return <>{showPrefix && <TagPrefix />}{children ?? tag}</>
}
